import { render, staticRenderFns } from "./WarehouseSingle.vue?vue&type=template&id=24517f38&"
import script from "./WarehouseSingle.vue?vue&type=script&lang=js&"
export * from "./WarehouseSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports